import type { Stroke } from './ink.js';
import { isHighlighter } from './pens.js';

export type RowMark = 'new' | 'task' | 'event' | 'note' | 'ignored' | 'changed' | null;

/**
 * Linhas novas: pelo menos um traço vivo, sem run, fora do cabeçalho.
 * Marca-texto não conta como conteúdo (SPEC §10.1) — grifar não é escrever.
 */
export function pendingRows(strokes: Iterable<Stroke>): number[] {
  const set = new Set<number>();
  for (const s of strokes) {
    if (s.deletedAt) continue;
    if (s.processedRunId) continue;
    if (isHighlighter(s.tool)) continue;
    if (s.row <= 0) continue;
    set.add(s.row);
  }
  return [...set].sort((a, b) => a - b);
}

/** Traços que entram numa leitura: os das linhas pedidas, vivos e não processados. */
export function strokesForRows(strokes: Iterable<Stroke>, rows: number[]): Stroke[] {
  const want = new Set(rows);
  return [...strokes].filter(
    (s) => !s.deletedAt && !s.processedRunId && !isHighlighter(s.tool) && want.has(s.row),
  );
}

/** Traços já lidos que servem de contexto na imagem (desenhados em cinza). */
export function contextStrokes(strokes: Iterable<Stroke>): Stroke[] {
  return [...strokes].filter((s) => !s.deletedAt && (!!s.processedRunId || s.row === 0));
}

export function hasLiveStrokes(strokes: Iterable<Stroke>, row: number): boolean {
  for (const s of strokes) if (!s.deletedAt && s.row === row) return true;
  return false;
}
